import { render, staticRenderFns } from "./chat-message-check-details.vue?vue&type=template&id=6777c034&scoped=true"
import script from "./chat-message-check-details.vue?vue&type=script&lang=js"
export * from "./chat-message-check-details.vue?vue&type=script&lang=js"
import style0 from "./chat-message-check-details.vue?vue&type=style&index=0&id=6777c034&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6777c034",
  null
  
)

export default component.exports